// Package Imports
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslate } from '@refinedev/core';
import { Modal } from 'antd';

// project imports

import ErrorTable from 'core/utils/errorTable';

const ErrorStackModal = ({
  isModalOpen,
  setIsModalOpen,
  setModalErrorData,
  isDeveloperMode,
  modalErrorData,
  sourceType,
}) => {
  const t = useTranslate();
  const handleModalCancel = () => {
    setIsModalOpen(false);
    setModalErrorData(null);
  };
  const regularError = [modalErrorData];

  return (
    <Modal
      title={
        <span className="flex gap-x-4 my-0">
          <ExclamationCircleOutlined style={{ color: 'red' }} />
          {t('common.error')}
        </span>
      }
      open={isModalOpen}
      onCancel={handleModalCancel}
      footer={null}
      maskClosable={false}
      width={isDeveloperMode ? '70%' : '50%'}
    >
      {/* regular error */}
      {regularError?.length > 0 ? (
        <ErrorTable
          errorData={regularError}
          isDeveloperMode={isDeveloperMode}
          sourceType={sourceType}
          handleModalCancel={handleModalCancel}
        />
      ) : null}
    </Modal>
  );
};

export default ErrorStackModal;
